import { render, staticRenderFns } from "./DeleteCourseRelationship.vue?vue&type=template&id=4d956106&scoped=true&"
import script from "./DeleteCourseRelationship.vue?vue&type=script&lang=js&"
export * from "./DeleteCourseRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d956106",
  null
  
)

export default component.exports